import { Card, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { formatDistance } from 'date-fns'

import { Post } from '../../../types/post'
import Share from '../Post/Share'
import { timeToRead } from '../../utils/string'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  authorContainer: {
    display: 'flex',
    flexDirection: 'row',
    margin: '20px 0',
    flexWrap: 'wrap',
    alignItems: 'center',
    '& h6': {
      fontWeight: 600,
      color: '#895DD1',
      marginRight: '10px',
    },
  },
  authorPhoto: {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginRight: '8px',
    border: '1px solid white',
  },
  authorInfo: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  textInfo: {
    display: 'flex',
    flexDirection: 'row',
  },
  authorName: {
    color: '#895DD1',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '14px',
  },
  postDate: {
    color: '#787878',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '14px',
    marginLeft: '5px',
  },
}))

interface Props {
  currentUrl: string
  post: Post
}

function AuthorCard(props: Props): JSX.Element {
  const classes = useStyles({})

  return (
    <div className={classes.root}>
      <div className={classes.authorContainer}>
        {props.post.authors.length ? (
          <img className={classes.authorPhoto} src={props.post.authors?.[0]?.photo?.url} />
        ) : null}
        <div className={classes.authorInfo}>
          <Typography className={classes.authorName}>{props.post.authors?.[0]?.name}</Typography>
          <div className={classes.textInfo}>
            <Typography
              className={classes.postDate}
              title={new Date(props.post.createdAt).toDateString()}
            >
              {formatDistance(new Date(props.post.createdAt), new Date())} ago ·
            </Typography>
            <Typography className={classes.postDate}>
              {timeToRead(props.post.text)} min read
            </Typography>
          </div>
        </div>
      </div>
      <Share currentUrl={props.currentUrl} />
    </div>
  )
}

export default AuthorCard
